import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import Loader from "../loader";
import ModalAlert from "../modal/modal_alert";
import ModalConfirm from "../modal/modal_confirm";
import ModalLoader from "../modal/modal_loader";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    circleId: PropTypes.number.isRequired,
    photo: PropTypes.object.isRequired,
    loadAlbumPhotosFromServer: PropTypes.func.isRequired,
  },
  getInitialState() {
    return {
      isActive: false,
      scrollPos: 0,
      isLoading: false,
      isPrivatePhotoDisplay: false,
      loadingPhoto: true,
      isFacePositionDisplay: false,
    };
  },
  callFaceRecognitionApi() {
    this.modalLoader.openModal();
    $.ajax({
      url: "/api/album/face_recognition/" + this.props.photo.id,
      type: "GET",
      data: {
        circle_id: this.props.circleId,
      },
      cache: false,
      success: function() {
        // this.modalLoader.closeModal();
        this.callProcessFaceMaskApi();
        // this.props.loadAlbumPhotosFromServer();
        // this.modalAlertStartFaceRecognitionDone.openModal();
      }.bind(this),
      error: function() {
        this.modalLoader.closeModal();
        this.modalAlertDeleteError.openModal();
      }.bind(this),
    });
  },
  callProcessFaceMaskApi() {
    this.modalLoader.openModal();
    $.ajax({
      url: "/api/album/process_face_mask/" + this.props.photo.id,
      type: "GET",
      data: {
        circle_id: this.props.circleId,
      },
      cache: false,
      success: function() {
        this.modalLoader.closeModal();
        this.props.loadAlbumPhotosFromServer();
        this.modalAlertStartProcessFaceMaskDone.openModal();
        this.setIsPrivate(true);
        this.setState({
          isPrivatePhotoDisplay: true,
          loadingPhoto: true,
        });
      }.bind(this),
      error: function() {
        this.modalLoader.closeModal();
        this.modalAlertDeleteError.openModal();
      }.bind(this),
    });
  },
  setIsPrivate(isPrivate) {
    $.ajax({
      url: "/api/album/set_is_private_photo_required/",
      type: "POST",
      data: {
        albums_photo_id: this.props.photo.id,
        is_private: isPrivate,
      },
      cache: false,
      success: function() {}.bind(this),
      error: function() {}.bind(this),
    });
  },
  openFaceMaskEditor() {
    var scrollPos = window.pageYOffset;
    var marginLeft =
      (window.innerWidth - $(".royal_preloader .container").outerWidth()) / 2;
    var width = window.innerWidth > 767 ? "" : "100%";
    $(document.body).css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
      width: width,
    });
    this.setState({
      isActive: true,
      scrollPos: scrollPos,
      isPrivatePhotoDisplay: this.props.photo.is_private_image_required
        ? true
        : false,
    });
  },
  closeFaceMaskEditor() {
    $(document.body).css({
      position: "relative",
      marginTop: "0",
      marginLeft: "0",
    });
    $(window).scrollTop(this.state.scrollPos);
    this.setState({
      isActive: false,
    });
  },
  handleCloseButton() {
    this.props.loadAlbumPhotosFromServer();
    this.closeFaceMaskEditor();
  },
  handleFaceRecognisionButton() {
    this.modalAlertStartFaceRecognition.openModal();
  },
  handleFacemaskButton() {
    this.modalConfirmStartProcessFaceMask.openModal();
  },
  handleShowImageButton() {
    this.setState({
      isPrivatePhotoDisplay: false,
      loadingPhoto: true,
    });
    this.setIsPrivate(false);
  },
  handleShowPrivateImageButton() {
    this.setState({
      isPrivatePhotoDisplay: true,
      loadingPhoto: true,
    });
    this.setIsPrivate(true);
  },
  handlePhotoLoaded() {
    this.setState({
      loadingPhoto: false,
    });
  },
  handleShowFacePositionButton() {
    this.setState({
      isFacePositionDisplay: !this.state.isFacePositionDisplay,
    });
  },
  render() {
    if (!this.state.isActive) {
      return <div />;
    }

    //画面のサイズを取得
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;

    // footerの高さを指定
    var footerHeight = 100;
    if (windowWidth < 768) footerHeight = 200;
    //headerの高さを指定
    var headerHeight = 50;
    //bodyの高さを指定
    var bodyHeight = windowHeight - footerHeight - headerHeight;
    var bodyWidth = windowWidth;

    //画像のCSSを決定
    var img = new Image();
    img.src = this.props.photo.photo_url;
    var imgWidth = img.width;
    var imgHeight = img.height;
    var bodyAspectRatio = (bodyWidth / bodyHeight).toFixed(2);
    var imgAspectRatio = (imgWidth / imgHeight).toFixed(2);
    var photoDirection =
      bodyAspectRatio - imgAspectRatio < 0 ? "photo-w" : "photo-h";

    //表示する画像
    var photo = "";
    if (!this.state.isPrivatePhotoDisplay) {
      photo = (
        <img
          id={photoDirection}
          src={this.props.photo.photo_url}
          onLoad={this.handlePhotoLoaded}
        />
      );
    } else {
      photo = (
        <img
          id={photoDirection}
          src={this.props.photo.private_photo_url}
          onLoad={this.handlePhotoLoaded}
        />
      );
    }
    return (
      <div className="face-mask-editor">
        <div id="over-all">
          <div id="overlay" />
          <div id="content">
            <div id="header" style={{ height: headerHeight + "px" }}>
              <div
                onClick={this.handleCloseButton}
                style={{
                  fontSize: "30px",
                  float: "left",
                  marginTop: "-12px",
                  fontWeight: "200",
                }}
              >
                ×
              </div>
            </div>
            <div
              id="body"
              style={{
                top: headerHeight + "px",
                height: bodyHeight + "px",
                width: bodyWidth + "px",
              }}
            >
              {photo}
              <div
                id="photo-obverlay"
                style={{ display: this.state.loadingPhoto ? "" : "none" }}
              >
                <Loader isActive={true} />
              </div>
            </div>
            <div id="footer" style={{ height: footerHeight + "px" }}>
              <p className="text-center">
                <button
                  type="button"
                  className="btn btn-md u-btn-outline-teal g-mr-10 g-mb-15"
                  onClick={this.handleFaceRecognisionButton}
                  disabled={this.props.photo.is_face_detected}
                >
                  顔検出
                </button>
                {/*<button type="button" className="btn btn-md u-btn-outline-teal g-mr-10 g-mb-15" onClick={this.handleShowFacePositionButton} disabled={!this.props.photo.is_face_detected}>顔表示</button> */}
                <button
                  type="button"
                  className="btn btn-md u-btn-outline-teal g-mr-10 g-mb-15"
                  onClick={this.handleFacemaskButton}
                  disabled={!this.props.photo.is_face_detected}
                >
                  再マスク処理
                </button>
                <br />
                <button
                  type="button"
                  className="btn btn-md u-btn-teal g-mr-10 g-mb-15"
                  onClick={this.handleShowImageButton}
                  disabled={
                    this.props.photo.photo_url &&
                    this.state.isPrivatePhotoDisplay
                      ? false
                      : true
                  }
                >
                  通常画像
                </button>
                <button
                  type="button"
                  className="btn btn-md u-btn-teal g-mr-10 g-mb-15"
                  onClick={this.handleShowPrivateImageButton}
                  disabled={
                    this.props.photo.private_photo_url &&
                    !this.state.isPrivatePhotoDisplay
                      ? false
                      : true
                  }
                >
                  マスク画像
                </button>
              </p>
            </div>
          </div>
        </div>
        <ModalAlert
          ref={(c) => {
            this.modalAlertStartFaceRecognition = c;
          }}
          title="顔の検出"
          content="画像解析を解析して、顔の検出を開始します。"
          approveFunc={this.callFaceRecognitionApi}
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertStartFaceRecognitionDone = c;
          }}
          title="顔の検出"
          content="画像解析の解析が完了しました。"
        />
        <ModalConfirm
          ref={(c) => {
            this.modalConfirmStartProcessFaceMask = c;
          }}
          title="マスク処理"
          content="現在の顔情報を元に画像にマスク処理を施しますか？"
          approveFunc={this.callProcessFaceMaskApi}
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertStartProcessFaceMaskDone = c;
          }}
          title="マスク処理"
          content="マスク処理が完了しました。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertDeleteError = c;
          }}
          title="エラー"
          content="時間を置いてもう一度試すか、運営にお問い合わせください。"
        />
        <ModalLoader
          ref={(c) => {
            this.modalLoader = c;
          }}
        />
      </div>
    );
  },
});
